export function once(fn) {
  let called = false;

  return function(...args) {
    if (!called) {
      called = true;
      return fn(...args);
    }
    return null;
  };
}

export function argsToArray(args) {
  return [].slice.call(args);
}

export function makePrevValReturner(fn) {
  let prevVal = null;
  let currentVal = null;

  return function(...args) {
    const result = fn(...args);
    if (result !== currentVal) {
      prevVal = currentVal;
      currentVal = result;
    }
    return prevVal;
  };
}
